import { KeyedMetrics } from "./keyedMetrics";

export class Metric {
    private _val: number | KeyedMetrics | null;

    static empty(): Metric {
        return new Metric(null);
    }

    static fromValue(value: number): Metric {
        return new Metric(value);
    }

    static fromSubMetrics(subMetrics: KeyedMetrics): Metric {
        return new Metric(subMetrics);
    }

    private constructor(val: number | KeyedMetrics | null) {
        this._val = val;
    }

    get hasValue(): boolean {
        return typeof(this._val) == "number";
    }

    get hasSubMetrics(): boolean {
        return this._val instanceof KeyedMetrics;
    }

    get value(): number {
        return this.hasValue ? this._val as number : 0;
    }

    get subMetrics(): KeyedMetrics {
        return this.hasSubMetrics ? this._val as KeyedMetrics : new KeyedMetrics();
    }

    get total(): number {
        if (this.hasSubMetrics) {
            return this.subMetrics.total;
        } else {
            return this.value;
        }
    }

    static isEqual(a: Metric, b: Metric): boolean {
        if (typeof(a._val) != typeof(b._val)) {
            return false;
        }
        if (a.hasSubMetrics) {
            return KeyedMetrics.isEqual(a.subMetrics, b.subMetrics);
        } else {
            return a.value == b.value;
        }
    }

    static aggregate(a: Metric, b: Metric): Metric {
        if (a.hasSubMetrics || b.hasSubMetrics) {
            let aggregatedSubMetrics = new KeyedMetrics();
            aggregatedSubMetrics.aggregateFrom(a.subMetrics);
            aggregatedSubMetrics.aggregateFrom(b.subMetrics);
            return Metric.fromSubMetrics(aggregatedSubMetrics);
        } else {
            return Metric.fromValue(a.value + b.value);
        }
    }

    static interpolate(a: Metric, b: Metric, t: number): Metric {
        if (a.hasSubMetrics || b.hasSubMetrics) {
            return Metric.fromSubMetrics(KeyedMetrics.interpolate(a.subMetrics, b.subMetrics, t));
        } else {
            return Metric.fromValue(a.value + t * (b.value - a.value));
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/metric.ts